import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrawer1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDrawer1"><Path d="M4.5 2.5H19.5V19.5H4.5V2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M19 11L5 11" stroke="currentColor" strokeLinecap="square"/><Path d="M6.75 19.75V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.25 19.75V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 6.5H14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 15H14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDrawer1;
